<template>
  <div class="user-wrapper" :class="theme">
    <!-- update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航 -->
    <!-- update-begin author:sunjianlei date:20191@20 for: 解决全局样式冲突的问题 -->
    <!--<span class="action" @click="showClick">
      <a-icon type="search"></a-icon>
    </span>
    &lt;!&ndash; update-begin author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框 &ndash;&gt;
    <component :is="searchMenuComp" v-show="searchMenuVisible || isMobile()" class="borders" :visible="searchMenuVisible" title="搜索菜单" :footer="null" @cancel="searchMenuVisible=false">
      <a-select
        class="search-input"
        showSearch
        :showArrow="false"
        placeholder="搜索菜单"
        optionFilterProp="children"
        :filterOption="filterOption"
        :open="isMobile()?true:null"
        :getPopupContainer="(node) => node.parentNode"
        :style="isMobile()?{width: '100%',marginBottom:'50px'}:{}"
        @change="searchMethods"
        @blur="hiddenClick"
      >
        <a-select-option v-for="(site,index) in searchMenuOptions" :key="index" :value="site.id">{{site.meta.title}}</a-select-option>
      </a-select>
    </component>-->
    <!-- update-end author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框 -->
    <!-- update-end author:sunjianlei date:20191220 for: 解决全局样式冲突的问题 -->
    <!-- update_end  author:zhaoxin date:20191129 for: 做头部菜单栏导航 -->
   <!-- <span class="action">
      <a class="logout_title" target="_blank" href="http://doc.jeecg.com">
        <a-icon type="question-circle-o"></a-icon>
      </a>
    </span>-->
    <!--<a-badge style="cursor: pointer" @click="openCall" v-has="'call:open'" v-if="!workbenchBorder">开启呼叫</a-badge>-->
    <!--<a-badge style="cursor: pointer" @click="closeCall" v-has="'call:open'" v-else>关闭呼叫</a-badge>-->
    <!--<router-link :to="{ path: '/dm/work/order',query:{type:1}}">-->
        <!--<span class="action" style="cursor: pointer;color: #ff0000;font-weight: 600" >-->
          <!--待处理工单 {{countMap.dcl}}-->
        <!--</span>-->
    <!--</router-link>-->
<!--    <span style="padding: 13px 9px;background: #fff;border-radius: 14px;cursor: pointer;margin-right: 10px" title="签到">-->
<!--      <img src="@/assets/driver/signin.png" style="width: 24px" />-->
<!--    </span>-->
<!--    <span style="padding: 13px 9px;background: #fff;border-radius: 14px;cursor: pointer" @click="showWxjS" v-has="'wx:retrieval'"  title="微信检索">-->
<!--      <img src="@/assets/driver/wx_hui.png" style="width: 24px" v-if="wx==1"/>-->
<!--      <img src="@/assets/driver/wx_lv.png" style="width: 24px" v-if="wx==2"/>-->
<!--    </span>-->

<!--    <header-notice class="action"  title="通知消息"/>-->

    <a-dropdown  :overlayStyle="{width:'200px',textAlign:'left'}">
      <span class="action action-full ant-dropdown-link user-dropdown-menu dm-user-trigger">
        <a-avatar class="avatar-head" size="small" :src="getAvatar()"/>
        <span class="dm-user-name">{{ nickname() || '个人中心' }}</span>
        <svg class="dm-user-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      </span>
      <a-menu slot="overlay" style="border-radius:12px" class="user-dropdown-menu-wrapper dm-user-menu">
        <a-menu-item key="3" class="ant-dropdown-menu-item-new" @click="uploadAvatar">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <span>修改头像</span>
        </a-menu-item>
        <a-menu-item key="4" @click="updatePassword" class="ant-dropdown-menu-item-new">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-item key="6" @click="clearCache" class="ant-dropdown-menu-item-new">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
          <span>清理缓存</span>
        </a-menu-item>
        <a-menu-item key="5" @click="toggleDarkMode" class="ant-dropdown-menu-item-new">
          <svg v-if="darkMode" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
          <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
          <span>{{ darkMode ? '浅色模式' : '深色模式' }}</span>
        </a-menu-item>
        <a-menu-divider/>
        <a-menu-item key="7"  @click="handleLogout" class="ant-dropdown-menu-item-new dm-user-logout">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <!--<span class="action">-->
      <!--<a class="logout_title" href="javascript:;" @click="handleLogout">-->
        <!--<a-icon type="logout"/>-->
        <!--<span v-if="isDesktop()">&nbsp;退出登录</span>-->
      <!--</a>-->
    <!--</span>-->
    <user-password ref="userPassword"></user-password>
    <depart-select ref="departSelect" :closable="true" title="部门切换"></depart-select>
    <setting-drawer ref="settingDrawer" :closable="true" title="系统设置"></setting-drawer>
    <user-head-img ref="userHeadImg"></user-head-img>
    <wx-modal ref="wxModal"></wx-modal>
    <my-notice-modal ref="myNoticeModal"></my-notice-modal>
  </div>
</template>

<script>
  import HeaderNotice from './HeaderNotice'
  import UserPassword from './UserPassword'
  import SettingDrawer from "@/components/setting/SettingDrawer";
  import DepartSelect from './DepartSelect'
  import { mapActions, mapGetters,mapState } from 'vuex'
  import { mixinDevice } from '@/utils/mixin.js'
  import { getFileAccessHttpUrl,getAction } from "@/api/manage"
  import Vue from 'vue'
  import { UI_CACHE_DB_DICT_DATA } from "@/store/mutation-types"
  import UserHeadImg from "./UserHeadImg";
  import WxModal from "../../views/dm3/driver/modal/WxModal";
  import MyNoticeModal from "@views/dm4/dmNotice/modules/MyNoticeModal.vue";


  export default {
    name: "UserMenu",
    mixins: [mixinDevice],
    data(){
      return{
        // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
        searchMenuOptions:[],
        searchMenuComp: 'span',
        searchMenuVisible: false,
        // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
        workbenchBorder:false,
        countMap:{},
        wx:1,
        darkMode: false
      }
    },
    components: {
      MyNoticeModal,
      WxModal,
      UserHeadImg,
      HeaderNotice,
      UserPassword,
      DepartSelect,
      SettingDrawer
    },
    props: {
      theme: {
        type: String,
        required: false,
        default: 'dark',
        clearidx:0
      }
    },
    /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    created() {
      let lists = []
      this.searchMenus(lists,this.permissionMenuList)
      this.searchMenuOptions=[...lists]
     // this.getOrderCount();
     //  let that = this;
     //  setInterval(function(){
     //    that.getOrderCount();
     //  },30*1000);
      this.checkWx();
      this.$nextTick(() => {
        this.$refs.myNoticeModal.show();
      })
    },
    mounted() {
      // 深色模式状态恢复（兼容旧键 dm-dark-mode；auto 跟随系统已废弃，落回白天）
      const mode = localStorage.getItem('dm-theme-mode')
      this.darkMode = mode === 'dark' || localStorage.getItem('dm-dark-mode') === '1'
      document.documentElement.classList.toggle('dm-dark', this.darkMode)
      //如果是单点登录模式
      if (process.env.VUE_APP_SSO == 'true') {
        let depart = this.userInfo().orgCode
        if (!depart) {
          this.updateCurrentDepart()
        }
      }
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList

      })
    },
    /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    watch: {
      // update-begin author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
      device: {
        immediate: true,
        handler() {
          this.searchMenuVisible = false
          this.searchMenuComp = this.isMobile() ? 'a-modal' : 'span'
        },
      },
      // update-end author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
    },
    methods: {
      /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      showClick() {
        this.searchMenuVisible = true
      },
      hiddenClick(){
        this.shows = false
      },
      /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      ...mapActions(["Logout"]),
      ...mapGetters(["nickname", "avatar","userInfo"]),
      getAvatar(){
        return getFileAccessHttpUrl(this.userInfo().avatar)
      },
      handleLogout() {
        const that = this

        this.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk() {
            return that.Logout({}).then(() => {
              // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
              that.$router.push({ path: '/user/login' });
              // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
              //window.location.reload()
            }).catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
          },
          onCancel() {
          },
        });
      },
      updatePassword(){
        let username = this.userInfo().username
        this.$refs.userPassword.show(username)
      },
      updateCurrentDepart(){
        this.$refs.departSelect.show()
      },
      systemSetting(){
        this.$refs.settingDrawer.showDrawer()
      },
      /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      searchMenus(arr,menus){
        for(let i of menus){
          if(!i.hidden && "layouts/RouteView"!==i.component){
           arr.push(i)
          }
          if(i.children&& i.children.length>0){
            this.searchMenus(arr,i.children)
          }
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      // update_begin author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
      searchMethods(value) {
        let route = this.searchMenuOptions.filter(item => item.id === value)[0]
        if (route.meta.internalOrExternal === true || route.component.includes('layouts/IframePageView')) {
          window.open(route.meta.url, '_blank')
        } else {
          this.$router.push({ path: route.path })
        }
        this.searchMenuVisible = false
      },
      // update_end author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
      /*update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      /*update_begin author:liushaoqian date:20200507 for: 刷新缓存*/
      // 深色模式开关（全局滤镜 invert + hue-rotate，白黑互换、彩色保持）
      toggleDarkMode(){
        this.darkMode = !this.darkMode
        localStorage.setItem('dm-theme-mode', this.darkMode ? 'dark' : 'light')
        document.documentElement.classList.toggle('dm-dark', this.darkMode)
      },
      clearCache(){
        getAction("sys/dict/refleshCache").then((res) => {
          if (res.success) {
            //重新加载缓存
            getAction("sys/dict/queryAllDictItems").then((res) => {
              if (res.success) {
                Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
                Vue.ls.set(UI_CACHE_DB_DICT_DATA, res.result, 7 * 24 * 60 * 60 * 1000)
              }
            })
            this.$message.success("刷新缓存完成！");
          }
        }).catch(e=>{
          this.$message.warn("刷新缓存失败！");
          console.log("刷新失败",e)
        })
      },getOrderCount(){
        var that =this;
        getAction("/dm/dmWorkOrder/getOrderCount",{}).then((res)=>{
          if(res.success){
            that.countMap = res.result;
            let title = "";
            if(that.countMap.dcl){
              title += "您有"+that.countMap.dcl+"条待处理工单";
            }
            setTimeout(function(){
             that.clearidx = that.gdTitle(title);
            },2000);
          }

        })
      },gdTitle(title){
        var that =this;
        if(title.length>6){
          if(title.indexOf("...")==-1){
            title = title+ "...";
          }
          document.title=title.substring(1,title.length)+title.substring(0,1);
          title=document.title.substring(0,title.length);

          setTimeout(function(){
            that.clearidx = that.gdTitle(title);
          },300);
        }else{
          document.title="嘀盟SCRM管理中心"
        }
      },uploadAvatar(){
          this.$refs.userHeadImg.edit();
      },checkWx(){
        getAction("/dm/dmPhone/countPhoneCure").then(res=>{
          if(res.success){
            if(res.result.num>0){
              this.wx = 2;
            }
          }
        })
      },showWxjS(){
        if(this.wx==2){
          this.$refs.wxModal.edit();
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  /* update_begin author:zhaoxin date:20191129 for: 让搜索框颜色能随主题颜色变换*/
  /* update-begin author:sunjianlei date:20191220 for: 解决全局样式冲突问题 */
  .user-wrapper .search-input {
    width: 180px;
    color: inherit;

    /deep/ .ant-select-selection {
      background-color: inherit;
      border: 0;
      border-bottom: 1px solid white;
      &__placeholder, &__field__placeholder {
        color: inherit;
      }
    }
  }
  .avatar-head{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
  }
  /* 个人中心按钮区：头像+昵称+箭头，hover 反馈 */
  .dm-user-trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 14px;
    border-radius: 18px;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .dm-user-trigger:hover {
    background: #e7edf5;
    color: #333;
  }
  .dm-user-name {
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dm-user-arrow {
    flex-shrink: 0;
    color: #999;
    transition: transform 0.2s ease;
  }
  .dm-user-trigger:hover .dm-user-arrow {
    transform: rotate(180deg);
  }
  /* 下拉菜单项：图标+文字左对齐 */
  .dm-user-menu .ant-dropdown-menu-item-new{
    display: flex;
    align-items: center;
    gap: 10px;
    width: 184px !important;
    margin: 4px 6px;
    height: 40px;
    border-radius: 8px;
    color: #666;
    font-size: 14px;
    text-align: left;
    line-height: 20px;
    padding: 0 12px !important;
    transition: all 0.15s ease;
  }
  .dm-user-menu .ant-dropdown-menu-item-new:hover {
    background: #e7edf5 !important;
    color: #333 !important;
  }
  .dm-user-menu .dm-user-logout {
    color: #ff4d4f;
  }
  .dm-user-menu .dm-user-logout:hover {
    background: #fff1f0 !important;
    color: #ff4d4f !important;
  }
  /* 保留旧类名兼容 */
  .ant-dropdown-menu-item-new{
    display: flex;
    align-items: center;
    gap: 10px;
    width: 184px !important;
    margin: 4px 6px;
    height: 40px;
    border-radius: 8px;
    color: #666;
    font-size: 14px;
    text-align: left;
    line-height: 20px;
    padding: 0 12px !important;
    transition: all 0.15s ease;
  }
  .ant-dropdown-menu-item-new:hover {
    background: #e7edf5 !important;
    color: #333 !important;
  }
  /* update-end author:sunjianlei date:20191220 for: 解决全局样式冲突问题 */
  /* update_end author:zhaoxin date:20191129 for: 让搜索框颜色能随主题颜色变换*/
  /deep/ .user-wrapper .action:hover,
  /deep/ .layout .top-nav-header-index.dark .user-wrapper .action:hover{
    background:inherit !important;
  }
</style>

<style scoped>
  .logout_title {
    color: inherit;
    text-decoration: none;
  }

</style>